import React from 'react';
import { FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy({ open, onClose }) {
  const { i18n } = useTranslation();
  const isJa = i18n.language?.startsWith('ja');

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className="relative z-10 w-full max-w-2xl bg-[#0d1f0b] border border-white/10 rounded-2xl overflow-hidden shadow-2xl flex flex-col"
        style={{ maxHeight: '85vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-white/10 shrink-0">
          <h2 className="text-white font-extrabold text-lg">
            {isJa ? 'プライバシーポリシー' : 'Privacy Policy'}
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-white/20 hover:text-white transition-all"
          >
            <FiX size={14} />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto flex-1 px-6 py-6">
          {isJa ? (
            <div className="text-white/75 text-sm leading-[1.9] space-y-5">

              <p>クイケルインターナショナル株式会社（以下、「当社」といいます。）は、当社が運営する「掛川バギー＆アウトドアパーク」（以下、「当サイト」といいます。）において、お客様の個人情報の保護を重要な責務と考え、以下のとおりプライバシーポリシーを定めます。</p>

              <div>
                <h3 className="text-white font-extrabold mb-2">第1条（個人情報の取得）</h3>
                <p>当社は、お問い合わせフォーム、予約フォーム、イベント申込フォーム、Googleフォーム等を通じて、お客様のお名前、電話番号、メールアドレスその他必要な情報を取得する場合があります。</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第2条（個人情報の利用目的）</h3>
                <p className="mb-2">当社は、取得した個人情報を以下の目的で利用します。</p>
                <ul className="space-y-1 pl-2">
                  {['お問い合わせへの回答','ご予約、お申込みの受付および確認','イベントやサービスに関するご案内','サービス向上のための分析および改善','お客様への連絡およびサポート対応','法令等に基づく対応'].map(item => (
                    <li key={item} className="flex items-start gap-2"><span className="text-[#7dc45a] shrink-0">・</span>{item}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第3条（個人情報の管理）</h3>
                <p>当社は、お客様の個人情報について、不正アクセス、紛失、漏えい、改ざん等を防止するため、適切な安全管理措置を講じます。</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第4条（第三者への提供）</h3>
                <p>当社は、法令に基づく場合を除き、お客様の同意なく第三者へ個人情報を提供することはありません。</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第5条（Cookieの利用）</h3>
                <p>当サイトでは、利便性向上および利用状況分析のため、Cookie（クッキー）を使用する場合があります。Cookieによって取得される情報には、個人を特定する情報は含まれません。</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第6条（アクセス解析ツール）</h3>
                <p>当サイトでは、Google Analytics等のアクセス解析ツールを利用する場合があります。これらのツールは、トラフィックデータ収集のためCookieを使用することがあります。</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第7条（個人情報の開示・訂正・削除）</h3>
                <p>お客様ご本人から、自己の個人情報について開示、訂正、追加、削除等の請求があった場合には、本人確認のうえ速やかに対応いたします。</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第8条（お問い合わせ窓口）</h3>
                <div className="bg-white/5 border border-white/10 rounded-xl px-4 py-4 space-y-1">
                  <p className="text-white font-bold">クイケルインターナショナル株式会社</p>
                  <p>掛川バギー＆アウトドアパーク</p>
                  <p>郵便番号：437-1435</p>
                  <p>電話番号：0537-26-9489</p>
                  <p>メールアドレス：kakegawabuggy@gmail.com</p>
                </div>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">第9条（プライバシーポリシーの変更）</h3>
                <p>当社は、法令の改正その他必要に応じて、本ポリシーを変更することがあります。変更後の内容は当サイトに掲載した時点で効力を生じるものとします。</p>
              </div>

              <div className="pt-2 border-t border-white/10">
                <p>制定日：2026年6月19日</p>
                <p className="mt-2 text-white font-bold">クイケルインターナショナル株式会社</p>
                <p>代表取締役　Ishwor Prasad Kuikel</p>
              </div>

            </div>
          ) : (
            <div className="text-white/75 text-sm leading-[1.9] space-y-5">

              <p>Kuikel International Co., Ltd. (hereinafter referred to as "the Company") recognizes the importance of protecting personal information and establishes the following Privacy Policy regarding the operation of Kakegawa Buggy & Outdoor Park (hereinafter referred to as "the Website").</p>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 1: Collection of Personal Information</h3>
                <p>The Company may collect personal information such as names, telephone numbers, email addresses, and other necessary information through inquiry forms, reservation forms, event registration forms, Google Forms, and similar services.</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 2: Purpose of Use</h3>
                <p className="mb-2">The personal information collected will be used for the following purposes:</p>
                <ul className="space-y-1 pl-2">
                  {['Responding to inquiries','Processing and confirming reservations and applications','Providing information regarding events and services','Improving and analyzing our services','Contacting and supporting customers','Complying with legal obligations'].map(item => (
                    <li key={item} className="flex items-start gap-2"><span className="text-[#7dc45a] shrink-0">·</span>{item}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 3: Management of Personal Information</h3>
                <p>The Company will take appropriate security measures to prevent unauthorized access, loss, leakage, alteration, or misuse of personal information.</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 4: Disclosure to Third Parties</h3>
                <p>The Company will not disclose or provide personal information to third parties without the customer's consent, except where required by law.</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 5: Use of Cookies</h3>
                <p>The Website may use cookies to improve user convenience and analyze website usage. Information collected through cookies does not include personally identifiable information.</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 6: Access Analysis Tools</h3>
                <p>The Website may use access analysis tools such as Google Analytics. These tools may use cookies to collect traffic data.</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 7: Disclosure, Correction, and Deletion of Personal Information</h3>
                <p>Customers may request the disclosure, correction, addition, or deletion of their personal information. The Company will respond promptly after verifying the identity of the requester.</p>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 8: Contact Information</h3>
                <div className="bg-white/5 border border-white/10 rounded-xl px-4 py-4 space-y-1">
                  <p className="text-white font-bold">Kuikel International Co., Ltd.</p>
                  <p>Kakegawa Buggy & Outdoor Park</p>
                  <p>Postal Code: 437-1435, Japan</p>
                  <p>Telephone: +81-537-26-9489</p>
                  <p>Email: kakegawabuggy@gmail.com</p>
                </div>
              </div>

              <div>
                <h3 className="text-white font-extrabold mb-2">Article 9: Changes to this Privacy Policy</h3>
                <p>The Company may revise this Privacy Policy as necessary in response to legal amendments or operational requirements. Any revisions shall become effective upon publication on the Website.</p>
              </div>

              <div className="pt-2 border-t border-white/10">
                <p>Established: June 19, 2026</p>
                <p className="mt-2 text-white font-bold">Kuikel International Co., Ltd.</p>
                <p>Representative Director: Ishwor Prasad Kuikel</p>
              </div>

            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-white/10 flex items-center justify-between shrink-0">
          <a
            href="tel:0537269489"
            className="text-[#ffd76a] text-xs font-bold hover:text-white transition-colors"
          >
            0537-26-9489
          </a>
          <button
            onClick={onClose}
            className="bg-[#ea622a] hover:bg-[#cf4f1f] text-white text-xs font-bold px-5 py-2 rounded-full transition-colors"
          >
            {isJa ? '閉じる' : 'Close'}
          </button>
        </div>
      </div>
    </div>
  );
}